<div class="form-group jbm-multi-select clearfix {{inputClass}} {{class}}" [ngClass]="{'stacked': labelStacked, 'readonly': !editable}">
   <div class="selector-container" [ngClass]="{'data-value': !editable}">
      <label *ngIf="labelCaption" for="{{id}}" class="{{labelClass}}" [ngClass]="{'col-form-label': !labelStacked, 'col-form-label-sm': sm, 'disabled': disabled}" (click)="hide()">
         {{labelCaption}}<span *ngIf="!editable">:</span>
         <span *ngIf="editable && required" class="asterix">*</span>
      </label>
      <label *ngIf="!editable" class="col-form-label">
         <span *ngFor="let s of selection; index as index" class="me-1">
            {{getOptionValue(s)}}<span *ngIf="s<selection.length">,</span>
         </span>
      </label>
      <div class="input-container">
         <div *ngIf="editable" id="{{id}}" class="box form-control" [ngClass]="{'form-select': editable, 'is-invalid': (submitted || touched) && required && !open && !selection.length, 'is-valid': touched && required && selection.length, 'disabled': disabled}"
            [attr.tabindex]="disabled ? -1 : 0" (click)="toggle()" (keydown.enter)="toggle()" (keydown.Tab)="hide()" (blur)="blur()">
            <div *ngIf="options.length && removeableSelection" class="selection">
               <span *ngFor="let s of selection" class="me-2" (click)="toggleOption(s); $event.stopPropagation()">
                  {{getOptionValue(s)}} <i class="fa fa-times"></i>
               </span>
            </div>
            <div *ngIf="options.length && !removeableSelection" class="selected">
               <span *ngFor="let s of selection" class="badge bg-light-darker text-dark me-1" (click)="toggle(); $event.stopPropagation()">
                  {{getOptionValue(s)}}
               </span>
            </div>
            <jbm-multi-select-options-list [id]="id" [editable]="editable" [dropUp]="dropUp" [options]="options"
               [open]="open" [selection]="selection" [minimumSelectionLength]="minimumSelectionLength" [disabled]="disabled" (onSelectionChange)="setSelection($event)">
            </jbm-multi-select-options-list>
         </div>
         <div class="invalid-feedback" [ngClass]="{'is-invalid': (submitted || touched) && required && !open && !selection.length}">
            <div class="error">{{'entity.requiredfield'|translate}}</div>
         </div>
      </div>      
   </div>
</div>
